import React, { useState, useEffect } from "react";
// import "../Styles/globals.css";
import { toAbsoluteUrl } from "../../../toAbsoluteUrl";
import { callApi } from "../../../API";
import { resendInvite, removeFromCompany } from "../../../allFunctions";
import Pagination from "../../../Components/pagination";
import { useNavigate } from "react-router-dom";
import BreadcrumbsComponent from "../../../Components/Breadcrumbs.jsx";

export default function WalletTransaction() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [firstLoadNoData, setFirstLoadNoData] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [breadCrump, setBreadCrump] = useState([
    { name: "Home", link: "/" },
    { name: "My Team", link: "businessDashboard/myteam" },
  ]);
  function getStudents() {
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "userTransactionList",
      page: page,
      limit: limit,
      lang: 1,
      // apiType: activePage,
      // bussinessUserId: '2974',
    }).then((data) => {
      console.log('data',data);
      
      
      setLoading(1);
      setData(data.data);
      if (firstLoad && data.usersInfo.length < 1) {
        setFirstLoadNoData(true);
      }
      setFirstLoad(false);
    }).catch((error)=>{
      console.log("error",error);
    });
  }
  useEffect(() => {
    getStudents();
  }, []);

  function displayBody() {
    let studentsList = "";
    studentsList = data.map((rowData, index) => {
      return (
        <tr key={index}>
          <td className="col-lg-2 col-6 order-1">
            <span className="d-block d-lg-none">Transaction ID </span>{" "}
            {rowData.transactionId == "" ? "-" : rowData.transactionId}
          </td>
          <td className="col-lg-2 col-6 order-2">
            <span className="d-block d-lg-none">Amount</span>{" "}
            <p
              className={`${
                rowData.topUp == 1 ? "plus-price " : "minus-price"
              } `}
            >
              {rowData.balance == "" ? "-" : rowData.balance}
            </p>
          </td>
          <td className="col-lg-2 col-6 order-3">
            <span className="d-block d-lg-none">Time & Date</span>{" "}
            {rowData.transactionDate == "" ? "-" : rowData.transactionDate}
          </td>
          <td className="col-lg-2 col-6 order-4">
            <span className="d-block d-lg-none">Payment Method</span>
            {rowData.paymentMethod == "" ? "-" : rowData.paymentMethod}
          </td>
          <td className="col-lg-2 col-6 order-4">
            <span className="d-block d-lg-none">Balance</span>
            {rowData.balance == "" ? "-" : rowData.balanceAfterTransaction}
          </td>
          <td className="d-lg-none d-block col-lg-2 col-12  align-text-media order-0">
            <div className="dropdown">
              <img
                // className="dropdown-toggle"
                type="button"
                id={`dropdownMenu${index}`}
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                src={toAbsoluteUrl("/media/images/action-icon.svg")}
                alt="action-icon"
              />
              <div
                className="dropdown-menu action-table-menu"
                aria-labelledby={`dropdownMenu${index}`}
              >
                {/* <button
                      onClick={() => {
                        if (rowData.statusOfInvitation == 0) {
                          resendInvite(rowData.userEmail);
                        } else {
                          handleOpen();
                        }
                      }}
                      className="dropdown-item"
                      type="button"
                    >
                      <img src={toAbsoluteUrl("/media/images/user-plus.svg")} />
                      <span>
                        {rowData.statusOfInvitation == 0
                          ? "Resend Invite"
                          : "Invite"}
                      </span>
                    </button> */}
              </div>
            </div>
          </td>
          <td className="d-lg-table-cell d-none col-lg-2 order-0">
            <div className="download-and-view-action">
              <div onClick={() => { window.location = rowData.recieptUrl}} className=" pointer d-flex gap-8">
              <img
                  className="notDark"
                  src={toAbsoluteUrl("/media/images/download-icon.svg")}
                  alt="download-icon"
                />
                 <img
                 className="darkMode"
                  src={toAbsoluteUrl("/media/images/download-icon-dark.svg")}
                  alt="download-icon"
                />
                <p>Receipt</p>
              </div>
              <div className="d-flex gap-8">
              <img
                  className="notDark"
                  src={toAbsoluteUrl("/media/images/eye (1).svg")}
                  alt="download-icon"
                />
                <img
                  className="darkMode"
                  src={toAbsoluteUrl("/media/images/eye (1)-dark.svg")}
                  alt="download-icon"
                />
                <p>View</p>
              </div>
            </div>
          </td>
        </tr>
      );
    });

    return studentsList;
  }
  function displayHead(params) {
    return (
      <tr className="d-none d-lg-table-row">
        <th className="col-2">Transaction ID </th>
        <th className="col-2">Amount </th>
        <th className="col-2">Time & Date </th>
        <th className="col-2">Payment Method </th>
        <th className="col-2">Balance </th>
        <th className="col-2">Actions</th>
      </tr>
    );
  }

  return (
    <div>
      {/* </div> */}
      {loading == 0 && false ? (
        <div className="display-flex-with-center justify-content-center mt-5">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      ) : (
        <>
          {users.length < 1 && firstLoadNoData && false ? (
            <div className="no-data-message mt-5">
              <p>You haven't made any transactions yet. </p>
            </div>
          ) : (
            <>
              <table id="table" class="dashboard-table mt-5">
                <thead>{displayHead()}</thead>
                <tbody>{displayBody()}</tbody>
              </table>
              <Pagination
              limit={limit}
              setLimit={setLimit}
              setPage={setPage}
              
              {...data}
            />
            </>
          )}
        </>
      )}
    </div>
  );
}
